type SimpleSearchFilterModule = typeof import('./simple-search-filter');

let modulePromise: Promise<SimpleSearchFilterModule> | null = null;

export const getSimpleSearchFilterModule =
  (): Promise<SimpleSearchFilterModule> => {
    if (!modulePromise) {
      modulePromise = import('./simple-search-filter');
    }

    return modulePromise;
  };
